/**
 * Update date: 24-05-2023
 * Screen 2041.1
 */
import useAxios from 'axios-hooks';
import LoadPanel from 'app/components/LoadPanel';
import React, { createContext, useContext, useState, useEffect } from 'react';
import useProfileInfo from 'hooks/useProfileInfo';

const List = React.lazy(() => import('./List'));
/**
 * create context
 */
const ReceivingScheduledContext = createContext({});

ReceivingScheduledContext.displayName = 'ReceivingScheduledContext';

export const useReceivingScheduled = () => {
  return useContext(ReceivingScheduledContext);
};

const ReceivingScheduledOrderDetailsInquiry = () => {
  const { vendorName, vendorId } = useProfileInfo();
  const [data, setData] = useState([]);
  const [formSearchData, setFormSearchData] = useState<any>({
    dataList: {
      receiveDueState: [],
      largeCategory: [],
      mediumCategory: [],
      smallCategory: [],
      subCategory: [],
      product: [],
      productGroup: [],
      vendor: [],
    },
    receiveDueState: '',
    fromDate: new Date(),
    toDate: new Date(),
    sendDueFromDate: new Date(),
    sendDueToDate: new Date(),
    largeCategory: '',
    mediumCategory: '',
    smallCategory: '',
    subCategory: '',
    product: '',
    productGroup: '',
    vendor: '',
  });

  const [{ loading: loadingfetchData }, refetchData] = useAxios(
    {},
    { manual: true, autoCancel: true, useCache: false },
  );
  /**
   * fetch data
   */
  useEffect(() => {
    if (!vendorId) return;
    setFormSearchData({
      ...formSearchData,
      disableVendor: true,
      dataList: {
        ...formSearchData?.dataList,
        vendor: [{ vendorId: vendorId, vendorName: vendorName }],
      },
    });
  }, [vendorId]);

  const value: any = {
    data,
    setData,
    refetchData,
    formSearchData,
    setFormSearchData,
  };

  return (
    <ReceivingScheduledContext.Provider value={value}>
      <React.Suspense fallback={<LoadPanel visible={true} />}>
        <LoadPanel visible={loadingfetchData} />
        <List />
      </React.Suspense>
    </ReceivingScheduledContext.Provider>
  );
};

export default ReceivingScheduledOrderDetailsInquiry;
